/*
    This file is part of Universal Sequencer.
    Universal Sequencer is free software: you can redistribute it and/or modif
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Universal Sequencer is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import Tone from 'tone';
import ipfsClient from 'decentralized/Ipfs.js';
var bufferToArrayBuffer = require('buffer-to-arraybuffer');

class AudioUnit {
    constructor(context=Tone.Master.context) {
        this.duration = 0;
        this.source = undefined;
        this.buffer = undefined;
        this.playbackRate = 1;
        this.looping = false;
        this.playSound.bind(this);
        this.context = context;
        this.seek.bind(this);
        this.stopSound.bind(this);
    }

    dispose() {
        if (this.source !== undefined) {
            this.source.disconnect();
        }
        this.buffer = undefined;
        this.source = undefined;
    }

    getContext() {
        return this.context;
    }

    playSound(x, duration) {
        if (x == undefined) {
            x = 0;
        }
        if (this.source != undefined) {
            this.source.stop();
        }
        this.source = Tone.Master.context.createBufferSource(); // creates a sound source
        this.source.connect(Tone.Master.context.destination);       // connect the source to the context's destination (the speakers)
        this.source.buffer = this.buffer;
        this.source.playbackRate.value = this.playbackRate;
        this.source.loop = false;
        this.source.start(0, Math.max(0, x), duration);
    }

    seek(x) {
        this.stopSound();
        this.playSound(x);
    }

    stopSound() {
        if (this.source != undefined) {
            this.source.stop();
        }
    }

    loadRawBuffer(buffer) {
        this.buffer = buffer;
        this.duration = buffer.duration;
    }
    
    setBuffer(buffer) {
        this.buffer = buffer;
        this.duration = buffer.duration;
    }
}

export default AudioUnit;

